// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2pWGD","footer":"ModalInfo_footer__3GCXG"};